/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} WarehouseInputs */

const en_warehouse = /** @type {(inputs: WarehouseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warehouse`)
};

const es_warehouse = /** @type {(inputs: WarehouseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Almacen`)
};

/**
* | output |
* | --- |
* | "Warehouse" |
*
* @param {WarehouseInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const warehouse = /** @type {((inputs?: WarehouseInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<WarehouseInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_warehouse(inputs)
	return es_warehouse(inputs)
});